import { autocomplete } from '@algolia/autocomplete-js';

type Item = {
  id: string;
  title: string;
  url: string;
};

const translations = JSON.parse(document.getElementById('autocomplete')?.dataset.translations ?? '') as Record<
  string,
  string
>;

const autocompleteSearch = autocomplete<Item>({
  container: '#autocomplete',
  placeholder: translations.placeholder,
  translations,
  getSources({ query }) {
    return [
      {
        sourceId: 'items',
        onSelect({ item }) {
          window.location.href = item.url;
        },
        getItems() {
          // Replace this with your actual data source or API call
          const items = JSON.parse(document.getElementById('autocomplete')?.dataset.items ?? '') as Item[];

          return (
            items
              // Filters items
              .filter(item => item.title.toLowerCase().includes(query.toLowerCase()))
              // Highlights items
              .map(item => ({
                ...item,
                title: item.title.toLowerCase().includes(query.toLowerCase())
                  ? item.title.replace(query, `__aa-highlight__${query}__/aa-highlight__`)
                  : item.title,
              }))
          );
        },
        templates: {
          item({ item, html, components }) {
            return html`
              <div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                  <div class="aa-ItemTitle">
                    ${components.Highlight({
                      hit: item,
                      attribute: 'title',
                      tagName: 'mark',
                    })}
                  </div>
                </div>
              </div>
            `;
          },
          noResults() {
            return translations.noResults;
          },
        },
      },
    ];
  },
  onReset() {
    // Handle reset
    console.log('Search reset');
  },
});

export default autocompleteSearch;
